// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_payment_components-module__block--3Yvsc{padding:8px 24px 0;position:relative}.lawyer_payment_components-module__title--1fsum{text-decoration:underline}.lawyer_payment_components-module__icon--1YHiN{padding-top:10px;line-height:inherit;vertical-align:bottom;font-size:16px;color:inherit;width:20px;position:absolute;top:0;left:0}\n", ""]);
// Exports
exports.locals = {
	"block": "lawyer_payment_components-module__block--3Yvsc",
	"title": "lawyer_payment_components-module__title--1fsum",
	"icon": "lawyer_payment_components-module__icon--1YHiN"
};
module.exports = exports;
